<form [formGroup]="filterForms" (ngSubmit)="checkAndCallMethods()">
    @if (localTableFilters) {
    <mat-form-field subscriptSizing="dynamic" class="filter">
        <mat-label>Filter</mat-label>
        <mat-select formControlName="tableFilter" (selectionChange)="changeValue($event)">
            @for (filter of localTableFilters; track filter) {
            <mat-option [value]="filter">
                {{filter.displayName}}
            </mat-option>
            }
        </mat-select>
    </mat-form-field>
    }

    @if (filterForms.get('tableFilter')?.value) {
    <mat-form-field subscriptSizing="dynamic" class="filter">
        <mat-label>{{filterForms.value.tableFilter.displayName || ''}}</mat-label>
        @if (isArray() && this.filterForms.value.tableFilter.displayName !== 'Contract Number') {
        <mat-select formControlName="value">
            @for (val of filterForms.value.tableFilter.values; track val) {
            <mat-option [value]="val">
                {{val?.value || val}}
            </mat-option>
            }
        </mat-select>
        } @else {
        <label>
            @if (this.filterForms.value.tableFilter.displayName !== 'Contract Number') {
            <input matInput placeholder="{{filterForms.value.tableFilter.displayName || ''}}" formControlName="value">
            }
        </label>
        }
        @if (this.filterForms.value.tableFilter.displayName === 'Contract Number') {
        <mat-select (click)="open($event)" [formGroup]="beComponentForm" formControlName="value">
            <div class="fixed">
                <mat-form-field subscriptSizing="dynamic" [floatLabel]="'auto'" style="margin: 5px;padding-left: 10px;padding-right: 10px;
                    border: 1.5px solid rgba(216, 220, 230, 0.87); border-radius: 5px;
                    position: absolute;top: 0;width: calc(100% - 10px);background: white;z-index: 100;height:65px;">
                    <input matInput [formControl]="value" style="padding-left:10px" (input)="lookup(inputFilter.value);"
                        #inputFilter>
                    <i class="fa fa-search" matPrefix></i>
                    <mat-icon matSuffix (click)="clean(inputFilter);" style="cursor: pointer;
                font-size: large;">close</mat-icon>
                </mat-form-field>
            </div>
            <div style="padding-top: 80px">
                @for (val of this.filteredOptions | async; track val) {
                <mat-option class="client" [value]="val">
                    <span> {{val?.value || val}}</span>
                </mat-option>
                }
            </div>
        </mat-select>
        }

    </mat-form-field>
    }
    <div class="buttons">
        <button mat-flat-button color="primary" class="button" type="submit" [disabled]="!isFilterSet()"
            (click)="isAddFilterCliecked()">Add</button>
        <button mat-flat-button color="primary" class="button" type="submit" [disabled]="!isWONumberFilterApplied()"
            (click)="isSearchClicked()">Search</button>
        <button mat-stroked-button class="button" [disabled]="!isAnyFilterSet()" (click)="reset()">Reset</button>
    </div>
    @if (filterAdded) {
    <div class="chips">
        <mat-chip-set class="example-chip-list" aria-label="Filter selection">
            @for (filters of filterArray; track filters) {
            <mat-chip (removed)="remove(filters.value)">
                {{filters.dispalyName}} - {{filters.value}}
                @if (removable) {
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
                }
            </mat-chip>
            }
        </mat-chip-set>
    </div>
    }
</form>
@if (isLoadingResults) {
<div class="loading-shade">
    @if (isLoadingResults) {
    <mat-spinner></mat-spinner>
    }
</div>
}